// extracted by mini-css-extract-plugin
export default {"container":"HomeBlock_container__-BJpq"};